import './services/firebase'; // Ensures Firebase is initialized on app start
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { setupPwaUpdates } from './pwaUpdate';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Show a "new version available — reload" prompt instead of silently serving
// stale cached code after a deploy.
setupPwaUpdates();